import * as React from 'react';
import * as styles from "./MessagesListView.css";
import { Helper } from '../../Helper';
import { IAIcon } from '../icon/Icon'
import { IUser } from '../../interfaces/IUser';
import { IAComments } from '../comments/Comments';
import { IALikes } from '../likes/Likes';
import { IAUniqueViews } from '../uniqueViews/UniqueViews';
import { ILike } from '../../interfaces/ILike';
import { LocalizationService } from '../../services/LocalizationService';
import { IMessage, IMessageCategory, IMessageIAConfiguration, IMessageIAMessageBgImagesFromBlob } from '../../interfaces/IMessage';
import { Environment } from '../../services/Environment';
import { IAMessageVideo } from '../messages/video/MessageVideo';
import { IAMessageCategories } from '../viewer/categories/MessageCategories';
import { IFontSlots } from '../../interfaces/IFontSlots';
import Moment from 'react-moment';
import { ENTER_KEY, SPACEBAR_KEY } from '../../global/Constants';

export interface IMessagesListViewProps {
  user?: IUser;
  author?: IUser;
  id?: string;
  tenant?: string;
  component?: string;
  instance?: string;
  token?: string;
  source?: string;
  index?: number;
  item?: any;
  isMobile?: boolean;
  environment?: "Development" | "Test" | "Production";
  resultSourceId?: string;
  siteCollection?: string;
  listName?: string;
  title?: string;
  image?: string;
  iaMessageBgImagesFromBlob?: IMessageIAMessageBgImagesFromBlob;
  iaConfiguration?: IMessageIAConfiguration;
  teaser?: string;
  videoUrl?: string;
  categories?: IMessageCategory[];
  showSkeleton?: boolean;
  likesEnabled?: boolean;
  reactionOptions?: string[];
  showEmojiPickerExpandButton?: boolean;
  commentsEnabled?: boolean;
  authorName?: string;
  authorProfileImage?: string;
  modifiedDate?: Date;
  backgroundColor?: string;
  borderColor?: string;
  borderRadius?: number;
  highlightColor?: string;
  itemTitleColor?: string;
  itemTextColor?: string;
  itemTitleStyle?: string;
  itemTitleSize?: number;
  itemTitleAlign?: string;
  itemTitleWeight?: string;
  width?: number;
  likes?: ILike[];
  commentCount?: number;
  hasDarkBackground?: boolean;
  onClickEdit?: (content: any) => void;
  onClickOpen?: (content: any) => void;
  onClickPreview?: (content: any) => void;
  onClickCopy?: (content: any) => void;
  onClickDelete?: (content: any) => void;
  likesUpdated?: (message: IMessage, likes: ILike[]) => void;
  commentsUpdated?: (message: IMessage, comments: number) => void;
  commentsClick?: () => void;
  showImage?: boolean;
  showTitle?: boolean;
  showCategories?: boolean;
  showTeaser?: boolean;
  showAuthor?: boolean;
  showStartDate?: boolean;
  showLikes?: boolean;
  showComments?: boolean;
  showDropShadow?: boolean;
  showCommandBarItems?: boolean;
  uniqueViewsCount?: number;
  showUniqueViews?: boolean;
  isUnread?: boolean;
  unReadHighlight?: string;
  isPanelOpen?: boolean;
  showPinIcon?: boolean;
  showLikesDimmed?: boolean;
  showCommentsDimmed?: boolean;
  showUniqueViewsDimmed?: boolean;
  fontSlots?: IFontSlots;
  userLocation?: string;
}

export interface IListViewSate {
  commandaBarOpen: boolean;
}

export class IAMessagesListView extends React.Component<IMessagesListViewProps, IListViewSate> {

  constructor(props: IMessagesListViewProps, state: IListViewSate) {
    super(props, state);
    this.state = {
      commandaBarOpen: false,
    }
  }

  public render(): JSX.Element {
    let commandBarItems: Array<any> = [];
    if (this.props.onClickEdit != undefined && !this.props.isMobile) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `edit-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickEdit(this.props.item)}
        >
          <IAIcon
            title="Edit"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Edit}
          </div>
        </div>
      );
    }
    if (this.props.onClickOpen != undefined) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `open-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickOpen(this.props.item)}
        >
          <IAIcon
            title="Open"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Open}
          </div>
        </div>
      );
    }
    if (this.props.onClickPreview != undefined) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `preview-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickPreview(this.props.item)}
        >
          <IAIcon
            title="Preview"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Preview}
          </div>
        </div>
      );
    }
    if (this.props.onClickCopy != undefined) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `copy-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickCopy(this.props.item)}
        >
          <IAIcon
            title="Copy"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Copy}
          </div>
        </div>
      );
    }

    if (this.props.onClickDelete != undefined && !this.props.isMobile) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `delete-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickDelete(this.props.item)}
        >
          <IAIcon
            title="Close"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Delete}
          </div>
        </div>
      );
    }
    let minHeight = 0;
    const likesShouldBeShown = this.props.likesEnabled && this.props.showLikes;
    const commentsShouldBeShown = this.props.commentsEnabled && this.props.showComments;

    let iconsAmount = 0;
    if (likesShouldBeShown) {
      iconsAmount++;
    }
    if (commentsShouldBeShown) {
      iconsAmount++;
    }
    if (this.props.showCommandBarItems) {
      iconsAmount++;
    }
    if (this.props.showUniqueViews) {
      iconsAmount++;
    }
    if (iconsAmount === 4) {
      minHeight = minHeight < 164 ? 164 : minHeight;
    }
    if (iconsAmount === 3) {
      minHeight = minHeight < 128 ? 128 : minHeight;
    }
    if (iconsAmount === 2) {
      minHeight = minHeight < 90 ? 90 : minHeight;
    }

    let thumbnailImageWidth = this.props.image != undefined && this.props.showImage ? 274 : 0;
    let thumbnailImageHeight = this.props.image != undefined && this.props.showImage ? 154 : 0;
    let skeletonTeaserHeight = 14;
    let thumbnailImage = this.props.image;
    if (this.props.showCommandBarItems && minHeight < 128) {
      minHeight = 128;
    }
    if (this.props.showImage) {
      if (this.props.width >= 750 && (this.props.image != undefined || this.props.videoUrl != undefined)) {
        thumbnailImageWidth = 274;
        thumbnailImageHeight = 154;
      } else if (this.props.width < 750 && this.props.width >= 570 && (this.props.image != undefined || this.props.videoUrl != undefined)) {
        thumbnailImageWidth = 194;
        thumbnailImageHeight = 126;
        skeletonTeaserHeight = 12;
      } else if (this.props.image != undefined || this.props.videoUrl != undefined) {
        thumbnailImageWidth = 117;
        thumbnailImageHeight = 94;
        skeletonTeaserHeight = 10;
      }
      minHeight = minHeight < thumbnailImageHeight ? thumbnailImageHeight : minHeight;
      if (thumbnailImageHeight < minHeight) {
        thumbnailImageHeight = minHeight;
      }

      if (this.props.iaMessageBgImagesFromBlob?.StandardSmall) {
        thumbnailImage = this.props.iaMessageBgImagesFromBlob?.StandardSmall;
      } else if (this.props.image != null) {
        thumbnailImage = thumbnailImage.replace(/StandardLarge|StandardSmall|Square|Wide|Full|DefaultRendition/, "StandardSmall").replace("version=&", `version=${this.props.item ? this.props.item.modified ? (new Date(this.props.item.modified)).toISOString().replace(/[^\d]/g, '') : "" : ""}&ignoreCache=false&`);
        thumbnailImage = Helper.getImageUrl(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, thumbnailImage, this.props.item ? this.props.item.modified ? (new Date(this.props.item.modified)).toISOString().replace(/[^\d]/g, '') : undefined : undefined, "StandardSmall", this.props.iaConfiguration?.cropSettings, false);
      }

      if (this.props.image == undefined && this.props.videoUrl && Helper.isYouTubeUrl(this.props.videoUrl)) {
        thumbnailImage = Helper.getYouTubeThumbnailFromURL(this.props.videoUrl);
      }
      if (this.props.videoUrl && (this.props.videoUrl.indexOf("microsoftstream") != -1 || (this.props.videoUrl.indexOf("sharepoint") != -1 && location.href.indexOf("sharepoint.com") == -1)) && this.props.image == undefined && this.props.isMobile) {
        thumbnailImage = "https://amsglob0cdnstream13.azureedge.net/streamlogo/Light_640x360.jpg";
      }
    }
    let commandBarWidth = (!this.props.showSkeleton && this.props.showLikes || !this.props.showSkeleton && this.props.showComments || !this.props.showSkeleton && this.props.showUniqueViews || !this.props.showSkeleton && this.props.showCommandBarItems) ? 40 : 0;
    let listHeight = 10;
    if (this.props.showTitle && this.props.title != undefined && this.props.title !== "") {
      listHeight += 35;
    }
    if (this.props.showTeaser && this.props.teaser != undefined) {
      listHeight += 45;
    }
    if (this.props.showCategories && this.props.categories != undefined && this.props.categories.length > 0) {
      listHeight += 22;
    }
    if (this.props.showAuthor || this.props.showStartDate) {
      listHeight += 32;
    }
    if (thumbnailImageHeight < listHeight) {
      thumbnailImageHeight = listHeight;
    }

    const hasCategories = this.props.showCategories && this.props.categories != undefined && this.props.categories.length > 0;
    return (
      <div
        className={`${styles.IA_list} IA_OnFocus`}
        tabIndex={0}
        style={{
          backgroundColor: this.props.backgroundColor != undefined ? this.props.backgroundColor : "transparent",
          borderColor: this.props.borderColor != undefined ? this.props.borderColor : "transparent",
          width: this.props.width,
          height: listHeight,
          minHeight: minHeight,
          borderRadius: this.props.borderRadius,
          boxShadow: this.props.showDropShadow ? "rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px" : "none",
        }}
        onContextMenu={(e) => e.preventDefault()}
        onKeyDown={(event) => {
          if (event.key === ENTER_KEY || event.key === SPACEBAR_KEY) {
            event.stopPropagation();
            if (this.props.onClickOpen) {
              this.props.onClickOpen(this.props.item);
            }
            event.currentTarget.blur();
          }
        }}
      >
        {this.props.isUnread && <div className={styles.IAUnread} style={{ borderLeft: `6px solid ${this.props.unReadHighlight ? this.props.unReadHighlight : "#ffb900"}` }}></div>}
        {(this.props.showImage && this.props.image || this.props.showImage && this.props.videoUrl) &&
          <div>
            {this.props.showPinIcon &&
              <div
                className={styles.IA_pinCoverOverlay}
                style={{
                  cursor: this.props.onClickOpen ? "pointer" : undefined,
                  left: thumbnailImageWidth - 30
                }}
                onClick={this.props.onClickOpen ? () => this.props.onClickOpen(this.props.item) : undefined}
              >
                <img
                  src="https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/pinned.png"
                  alt=""
                  style={{
                    width: 22,
                    height: 22
                  }}
                />
              </div>
            }
            {this.props.videoUrl && (this.props.videoUrl.indexOf("microsoftstream") != -1 || (this.props.videoUrl.indexOf("sharepoint") != -1 && location.href.indexOf("sharepoint.com") == -1)) && this.props.isMobile && this.props.image == undefined ?
              <a href={this.props.videoUrl} target="_blank">
                <div
                  className={styles.image}
                  style={{
                    backgroundImage: `url('${thumbnailImage}')`,
                    width: thumbnailImageWidth,
                    height: thumbnailImageHeight,
                    float: "left"
                  }}
                  onClick={this.props.image ? () => this.props.onClickOpen(this.props.item) : undefined}
                />
              </a>
              :
              <div
                className={styles.image}
                style={{
                  backgroundImage: `url('${thumbnailImage}')`,
                  width: thumbnailImageWidth,
                  height: thumbnailImageHeight,
                  float: "left"
                }}
                onClick={this.props.image ? () => this.props.onClickOpen(this.props.item) : undefined}
              >
                {this.props.videoUrl != undefined && this.props.image == undefined &&
                  <IAMessageVideo
                    id={this.props.id}
                    width={thumbnailImageWidth}
                    height={thumbnailImageHeight}
                    videoUrl={this.props.videoUrl}
                    environment={this.props.environment}
                    tenant={this.props.tenant}
                    token={this.props.token}
                    forceStop={this.props.isPanelOpen}
                    fixSmallYTThumbnail
                  />
                }
              </div>
            }
          </div>
        }
        {
          !this.props.showSkeleton &&
          <div
            style={{
              color: this.props.itemTextColor,
              float: "left",
              height: "100%",
              width: `calc(100% - ${thumbnailImageWidth + commandBarWidth}px)`,
              cursor: "pointer"
            }}
            onClick={() => this.props.onClickOpen(this.props.item)}
          >
            {hasCategories &&
              <IAMessageCategories
                categories={this.props.categories}
                paddingLeft={10}
                paddingRight={10}
                paddingTop={5}
                showOverflowCounter
                fontSlots={this.props.fontSlots}
                disablePopup={this.props.isMobile}
                textColorWhenTransparentBackground={this.props.itemTextColor}
              />
            }
            {this.props.showTitle &&
              <div
                className={styles.IA_title}
                style={{
                  paddingTop: hasCategories ? 5 : 12,
                  fontWeight: this.props.isUnread ? "bold" : "normal",
                  fontFamily: this.props.fontSlots?.heading?.fontFamily
                }}
              >
                {this.props.title}
              </div>
            }
            {this.props.showTeaser && this.props.teaser != undefined &&
              <div
                className={styles.IA_teaser}
                style={{
                  fontFamily: this.props.fontSlots?.body?.fontFamily
                }}
              >
                {this.props.teaser}
              </div>
            }
            {(this.props.showAuthor || this.props.showStartDate) &&
              <div
                className={styles.IA_authorAndDate}
                style={{
                  width: `calc(100% - ${thumbnailImageWidth}px)`,
                  fontFamily: this.props.fontSlots?.body?.fontFamily
                }}
              >
                {!this.props?.iaConfiguration?.fieldsToHide?.includes("author") && this.props.author != undefined && this.props.author.displayName != undefined && this.props.showAuthor &&
                  <div
                    className={styles.IA_author}
                    style={{
                      fontFamily: this.props.fontSlots?.body?.fontFamily
                    }}
                  >
                    {`${this.props.author.displayName} `}
                  </div>
                }
                {this.props.showStartDate &&
                  <div
                    style={{
                      float: "left",
                      fontFamily: this.props.fontSlots?.body?.fontFamily
                    }}
                  >
                    <Moment
                      format="L"
                      locale={this.props.userLocation ?? navigator.language}
                    >
                      {this.props.modifiedDate}
                    </Moment>
                  </div>
                }
              </div>
            }
          </div>
        }
        {
          (!this.props.showSkeleton && likesShouldBeShown || !this.props.showSkeleton && commentsShouldBeShown || !this.props.showSkeleton && this.props.showUniqueViews || !this.props.showSkeleton && this.props.showCommandBarItems) &&
          <div
            className={styles.IA_commandBar}
            style={{
              borderColor: `${this.props.itemTextColor}20`
            }}
          >
            {likesShouldBeShown && this.props.id != undefined &&
              <IALikes
                highlightColor={this.props.highlightColor}
                color={this.props.itemTextColor}
                itemId={this.props.id}
                user={this.props.user}
                tenant={this.props.tenant}
                component={this.props.component}
                instance={this.props.instance}
                token={this.props.token}
                environment={this.props.environment}
                source={this.props.source}
                likes={this.props.likes}
                likesUpdated={(likes: ILike[]) => this.props.likesUpdated(this.props.item, likes)}
                displayVertical={true}
                showDimmed={this.props.showLikesDimmed}
                showEmojiPickerExpandButton={this.props.showEmojiPickerExpandButton}
                reactionOptions={this.props.reactionOptions}
                isMobile={this.props.isMobile}
              />
            }
            {commentsShouldBeShown && this.props.id != undefined &&
              <IAComments
                color={this.props.highlightColor}
                itemId={this.props.id}
                user={this.props.user}
                tenant={this.props.tenant}
                component={this.props.component}
                instance={this.props.instance}
                token={this.props.token}
                environment={this.props.environment}
                commentCount={this.props.commentCount}
                commentsUpdated={(comments: number) => this.props.commentsUpdated(this.props.item, comments)}
                commentsClick={() => { this.props.commentsClick() }}
                displayVertical={true}
                showDimmed={this.props.showCommentsDimmed}
              />
            }
            {this.props.showUniqueViews && this.props.id != undefined &&
              <IAUniqueViews
                color={this.props.highlightColor}
                itemId={this.props.id}
                user={this.props.user}
                tenant={this.props.tenant}
                component={this.props.component === "Messages" ? "Message" : "Event"}
                instance={this.props.instance}
                token={this.props.token}
                environment={this.props.environment}
                source={this.props.source}
                uniqueViews={this.props.uniqueViewsCount}
                displayVertical={true}
                showDimmed={this.props.showUniqueViewsDimmed}
              />
            }
            {this.props.showCommandBarItems && this.props.showCommandBarItems &&
              <div className={styles.IA_listElementContainer}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ commandaBarOpen: !this.state.commandaBarOpen })
                }}
              >
                <div className={styles.IA_cardBarBtn}>
                  <IAIcon
                    title="Show Action"
                    size={18}
                    color={this.props.highlightColor}
                  /></div>
                {this.state.commandaBarOpen &&
                  <ul
                    className={styles.IA_cardBarItems}
                  >
                    {commandBarItems}
                  </ul>}
              </div>
            }
          </div>
        }
        {
          this.props.showSkeleton &&
          <div
            className={styles.IA_skeleton}
            style={{
              opacity: this.props.hasDarkBackground ? 0.1 : 1
            }}
          >
            {this.props.showImage &&
              <div
                className={styles.IA_skeletonImage}
                style={{
                  width: thumbnailImageWidth,
                }}
              />
            }
            {this.props.showTitle &&
              <div
                className={styles.IA_skeletonHeadline}
                style={{
                  width: "40%",
                }}
              />
            }
            {this.props.showTeaser &&
              <div
                className={styles.IA_skeletonText}
                style={{
                  height: skeletonTeaserHeight,
                  width: `calc(100% - ${thumbnailImageWidth + 80}px)`
                }}
              />
            }
            {this.props.showTeaser &&
              <div
                className={styles.IA_skeletonText2}
                style={{
                  height: skeletonTeaserHeight,
                  width: `calc(100% - ${thumbnailImageWidth + 80}px)`
                }}
              />
            }
            {(this.props.showAuthor || this.props.showStartDate) &&
              <div
                className={styles.IA_skeletonPersonaText}
                style={{
                }}
              />
            }
          </div>
        }
      </div >
    );
  }


}